<template>
  <v-container
    id="detalhe-historico-inadimplencia-clientes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row v-if="!paginaEnable">
      <h1>
        Usuário não tem permissão a essa página não existente
      </h1>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <dashboard-filtro-datas
              :primeiro="enablePrimeiroDia"
              :ultimo="enableUltimoDia"
              :empresas="enableEmpresa"
              :cliente="enableClientes"
              :url="link"
            />
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <h3 class="text-center">
                        Histórico Clientes Inadimplentes
                      </h3>
                    </v-col>
                  </v-row>
                  <v-row v-if="loading">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        :style="styleObject"
                        class="text-center"
                      >
                        <v-icon
                          light
                          class="custom-loader"
                          :style="styleObject"
                        >
                          mdi-cached
                        </v-icon>
                        Carregando dados...
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="error">
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <div
                        class="alert alert-danger"
                      >
                        {{ error }}
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                        >
                          <!-- Tabela principal Inicio -->
                          <div
                            id="idTable"
                            style="overflow-x: auto; max-width: 100%;"
                          >
                            <table
                              style="width: 100%; color: black; border-collapse: collapse;"
                              class="elevation-1"
                            >
                              <thead>
                                <tr>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: left; width: 25%;"
                                    class="black--text title"
                                  >
                                    Nome reduzido
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: left; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    Cod. lançamento
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;  width: 12.5%;"
                                    class="black--text title"
                                  >
                                    Valor Vencido
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    % Vencido
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    Dias vencido
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    Valor aberto
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    % Inadimplência
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="item in dadosDetalhamento"
                                  :key="item.id"
                                  style="cursor: pointer;"
                                >
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: left; width: 25%;"
                                  >
                                    <v-icon
                                      id="iconInformationValorVencido"
                                      class="text-left"
                                      :style="styleObjectIcon"
                                      @click="expandedNome(item.nome_reduzido)"
                                    >
                                      {{ iconeNome }}
                                    </v-icon>
                                    {{ item.nome_reduzido }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: left;  width: 12.5%;"
                                  >
                                    <v-icon
                                      id="iconInformationValorVencido"
                                      class="text-left"
                                      :style="styleObjectIcon"
                                      @click="expandedLancamento(item.cod_lancamento)"
                                    >
                                      {{ iconeLancamento }}
                                    </v-icon>
                                    {{ item.cod_lancamento }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.valor_vencido }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.porcentagem_vendido }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.dias_vencido }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.valor_aberto }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.porcentagem_inadiplencia }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <!-- Tabela principal Fim -->
                          <!-- Tabela Nome Incio -->
                          <div
                            v-if="expandNome"
                            id="idTable"
                            style="overflow-x: auto; max-width: 100%;"
                          >
                            <table
                              style="width: 100%; color: black; border-collapse: collapse;"
                              class="elevation-1"
                            >
                              <thead>
                                <tr>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: left; width: 25%;"
                                    class="black--text title"
                                  >
                                    Nome reduzido
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: left; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    Cod. lançamento
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;  width: 12.5%;"
                                    class="black--text title"
                                  >
                                    Valor Vencido
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    % Vencido
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    Dias vencido
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    Valor aberto
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    % Inadimplência
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="item in dadosDetalhamentoNome"
                                  :key="item.id"
                                  style="cursor: pointer;"
                                >
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: left; width: 25%;"
                                  >
                                    {{ item.nome_reduzido }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: left;  width: 12.5%;"
                                  >
                                    {{ item.cod_lancamento }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.valor_vencido }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.porcentagem_vendido }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.dias_vencido }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.valor_aberto }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.porcentagem_inadiplencia }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <!-- Tabela nome Fim -->
                          <!-- Tabela Lancamento Incio -->
                          <div
                            v-if="expandLancamento"
                            id="idTable"
                            style="overflow-x: auto; max-width: 100%;"
                          >
                            <table
                              style="width: 100%; color: black; border-collapse: collapse;"
                              class="elevation-1"
                            >
                              <thead>
                                <tr>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: left; width: 25%;"
                                    class="black--text title"
                                  >
                                    Nome reduzido
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: left; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    Cod. lançamento
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;  width: 12.5%;"
                                    class="black--text title"
                                  >
                                    Valor Vencido
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    % Vencido
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    Dias vencido
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    Valor aberto
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    % Inadimplência
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="item in dadosDetalhamentoLancamento"
                                  :key="item.id"
                                  style="cursor: pointer;"
                                >
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: left; width: 25%;"
                                  >
                                    {{ item.nome_reduzido }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: left;  width: 12.5%;"
                                  >
                                    {{ item.cod_lancamento }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.valor_vencido }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.porcentagem_vendido }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.dias_vencido }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.valor_aberto }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.porcentagem_inadiplencia }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <!-- Tabela Lancamento Fim -->
                          <!-- Tabela Nome Lancamento Incio -->
                          <div
                            v-if="expandNomeLancamento"
                            id="idTable"
                            style="overflow-x: auto; max-width: 100%;"
                          >
                            <table
                              style="width: 100%; color: black; border-collapse: collapse;"
                              class="elevation-1"
                            >
                              <thead>
                                <tr>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: left; width: 25%;"
                                    class="black--text title"
                                  >
                                    Nome reduzido
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: left; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    Cod. lançamento
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center;  width: 12.5%;"
                                    class="black--text title"
                                  >
                                    Valor Vencido
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    % Vencido
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    Dias vencido
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    Valor aberto
                                  </th>
                                  <th
                                    id="dadoMovimentacaoHeader"
                                    style="text-align: center; width: 12.5%;"
                                    class="black--text title"
                                  >
                                    % Inadimplência
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="item in dadosDetalhamentoNomeLancamento"
                                  :key="item.id"
                                  style="cursor: pointer;"
                                >
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: left; width: 25%;"
                                  >
                                    {{ item.nome_reduzido }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: left;  width: 12.5%;"
                                  >
                                    {{ item.cod_lancamento }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.valor_vencido }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.porcentagem_vendido }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.dias_vencido }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.valor_aberto }}
                                  </td>
                                  <td
                                    id="dadoMovimentacao"
                                    style="text-align: right; width: 12.5%;"
                                  >
                                    {{ item.porcentagem_inadiplencia }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <!-- Tabela Nome Lancamento Fim -->
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import ContasReceber from '../../../../../services/contasreceber'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardContasVencidaDetalhamento',
    components: {
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      styleObject: {
        color: localStorage.corPrimaria,
      },
      valorReceber: localStorage.valorReceber,
      valorVencido: 0,
      paginaEnable: false,
      permissaoContasReceber: '',
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      selectClientes: [],
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableClientes: true,
      link: localStorage.linkContasReceber,
      headersDetalhamento: [
        { text: 'Nome reduzido', value: 'nome_reduzido', width: '350px', class: 'black--text title' },
        { text: 'Cod. lançamento', value: 'cod_lancamento', width: '250px', class: 'black--text title' },
        { text: 'Valor Vencido', value: 'valor_vencido', width: '100px', align: 'right', class: 'black--text title' },
        { text: '% Vencido', value: 'porcentagem_vendido', width: '100px', align: 'right', class: 'black--text title' },
        { text: 'Dias vencido', value: 'dias_vencido', width: '100px', align: 'right', class: 'black--text title' },
        { text: 'Valor aberto', value: 'valor_aberto', width: '100px', align: 'right', class: 'black--text title' },
        { text: '% Inadimplência', value: 'porcentagem_inadiplencia', width: '110px', align: 'right', class: 'black--text title' },
      ],
      dadosDetalhamento: [],
      dadosDetalhamentoNome: [],
      dadosDetalhamentoLancamento: [],
      dadosDetalhamentoNomeLancamento: [],
      iconeNome: 'mdi-plus',
      iconeLancamento: 'mdi-plus',
      expandNome: false,
      expandLancamento: false,
      expandNomeLancamento: false,
      loading: false,
      error: null,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        this.paginaEnable = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, selectVendedores, selectArea, selectRede, selectSupervisor, selectReceita, selectSegmento, selectClassificacao, selectProduto, selectCidade, selectCategoria, selectPromotor, selectLinhasProducao, primeiroDiaStatus, dateStatus, selectMotorista, selectStatusEntrega, selectOrdem, selectOpcaoOrdenacao, selectOrientacaoOrdem, selectClientes) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.selectClientes = selectClientes

        this.updateDate()
      },

      updateDate () {
        this.dadosDetalhamento = []

        this.showDelhamentoHistoricoInadimplenciaClientes()
      },

      async showDelhamentoHistoricoInadimplenciaClientes () {
        this.loading = true

        await ContasReceber.showHistoricoInadimplenciaClientes(this.primeiroDia, this.ultimoDia, this.select, this.valorReceber, localStorage.tokencontrato, this.selectClientes).then(resposta => {
          if (resposta.data.status) {
            this.dadosDetalhamento = resposta.data.dadosExibicao.map((item) => {
              this.valorVencido = item.valor_vencido

              var listaDetalhamento = ({
                nome_reduzido: item.nome_reduzido,
                cod_lancamento: item.cod_lancamento,
                valor_vencido: item.valor_vencido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                porcentagem_vendido: item.porcentagem_vendido,
                dias_vencido: item.dias_vencido,
                valor_aberto: item.valor_aberto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                porcentagem_inadiplencia: item.porcentagem_inadiplencia,
              })

              return listaDetalhamento
            })
          } else if (resposta.data.msg === 'Não há dados disponíveis') {
            this.dadosDetalhamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      async expandedNome (value) {
        if (!this.expandNome) {
          this.iconeNome = 'mdi-minus'

          if (this.expandNomeLancamento && this.iconeLancamento === 'mdi-minus') {
            this.iconeNome = 'mdi-plus'
            this.expandLancamento = true
            this.expandNomeLancamento = false
            this.dadosDetalhamentoNome = []
            this.dadosDetalhamentoLancamento = []

            this.loading = true

            await ContasReceber.showHistoricoInadimplenciaClientesLancamento(this.primeiroDia, this.ultimoDia, this.select, this.valorReceber, this.valorVencido, localStorage.tokencontrato, this.selectClientes).then(resposta => {
              if (resposta.data.status) {
                this.dadosDetalhamentoLancamento = resposta.data.dadosExibicao.map((item) => {
                  var listaDetalhamento = ({
                    nome_reduzido: item.nome_reduzido,
                    cod_lancamento: item.cod_lancamento,
                    valor_vencido: item.valor_vencido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                    porcentagem_vendido: item.porcentagem_vendido,
                    dias_vencido: item.dias_vencido,
                    valor_aberto: item.valor_aberto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                    porcentagem_inadiplencia: item.porcentagem_inadiplencia,
                  })

                  return listaDetalhamento
                })
              } else if (resposta.data.msg === 'Não há dados disponíveis') {
                this.dadosDetalhamentoLancamento = []

                this.showSnackbar('error', 3000, resposta.data.msg)
              }
            }).catch(e => {
              if (e.message === 'Network Error') {
                this.error = e.message

                this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
              }
            }).finally(f => { this.loading = false })
          } else if (this.iconeLancamento === 'mdi-minus') {
            this.expandedNomeLancamento(value)
          } else {
            this.expandNome = true

            this.loading = true

            await ContasReceber.showHistoricoInadimplenciaClientesNomes(this.primeiroDia, this.ultimoDia, this.select, this.valorReceber, this.valorVencido, localStorage.tokencontrato, this.selectClientes).then(resposta => {
              if (resposta.data.status) {
                this.dadosDetalhamentoNome = resposta.data.dadosExibicao.map((item) => {
                  var listaDetalhamento = ({
                    nome_reduzido: item.nome_reduzido,
                    cod_lancamento: item.cod_lancamento,
                    valor_vencido: item.valor_vencido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                    porcentagem_vendido: item.porcentagem_vendido,
                    dias_vencido: item.dias_vencido,
                    valor_aberto: item.valor_aberto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                    porcentagem_inadiplencia: item.porcentagem_inadiplencia,
                  })

                  return listaDetalhamento
                })
              } else if (resposta.data.msg === 'Não há dados disponíveis') {
                this.dadosDetalhamentoNome = []

                this.showSnackbar('error', 3000, resposta.data.msg)
              }
            }).catch(e => {
              if (e.message === 'Network Error') {
                this.error = e.message

                this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
              }
            }).finally(f => { this.loading = false })
          }
        } else {
          this.expandNome = false
          this.iconeNome = 'mdi-plus'
          // this.showDelhamentoHistoricoInadimplencia()
        }
      },

      async expandedLancamento (value) {
        if (!this.expandLancamento) {
          this.iconeLancamento = 'mdi-minus'

          if (this.expandNomeLancamento && this.iconeNome === 'mdi-minus') {
            this.iconeLancamento = 'mdi-plus'
            this.expandNome = true
            this.expandNomeLancamento = false

            this.dadosDetalhamentoNome = []
            this.dadosDetalhamentoLancamento = []

            this.loading = true

            await ContasReceber.showHistoricoInadimplenciaClientesNomes(this.primeiroDia, this.ultimoDia, this.select, this.valorReceber, this.valorVencido, localStorage.tokencontrato, this.selectClientes).then(resposta => {
              if (resposta.data.status) {
                this.dadosDetalhamentoNome = resposta.data.dadosExibicao.map((item) => {
                  var listaDetalhamento = ({
                    nome_reduzido: item.nome_reduzido,
                    cod_lancamento: item.cod_lancamento,
                    valor_vencido: item.valor_vencido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                    porcentagem_vendido: item.porcentagem_vendido,
                    dias_vencido: item.dias_vencido,
                    valor_aberto: item.valor_aberto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                    porcentagem_inadiplencia: item.porcentagem_inadiplencia,
                  })

                  return listaDetalhamento
                })
              } else if (resposta.data.msg === 'Não há dados disponíveis') {
                this.dadosDetalhamentoNome = []

                this.showSnackbar('error', 3000, resposta.data.msg)
              }
            }).catch(e => {
              if (e.message === 'Network Error') {
                this.error = e.message

                this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
              }
            }).finally(f => { this.loading = false })
          } else if (this.iconeNome === 'mdi-minus') {
            this.expandedNomeLancamento(value)
          } else {
            this.expandLancamento = true

            this.loading = true

            await ContasReceber.showHistoricoInadimplenciaClientesLancamento(this.primeiroDia, this.ultimoDia, this.select, this.valorReceber, this.valorVencido, localStorage.tokencontrato, this.selectClientes).then(resposta => {
              if (resposta.data.status) {
                this.dadosDetalhamentoLancamento = resposta.data.dadosExibicao.map((item) => {
                  var listaDetalhamento = ({
                    nome_reduzido: item.nome_reduzido,
                    cod_lancamento: item.cod_lancamento,
                    valor_vencido: item.valor_vencido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                    porcentagem_vendido: item.porcentagem_vendido,
                    dias_vencido: item.dias_vencido,
                    valor_aberto: item.valor_aberto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                    porcentagem_inadiplencia: item.porcentagem_inadiplencia,
                  })

                  return listaDetalhamento
                })
              } else if (resposta.data.msg === 'Não há dados disponíveis') {
                this.dadosDetalhamentoLancamento = []

                this.showSnackbar('error', 3000, resposta.data.msg)
              }
            }).catch(e => {
              if (e.message === 'Network Error') {
                this.error = e.message

                this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
              }
            }).finally(f => { this.loading = false })
          }
        } else {
          this.iconeLancamento = 'mdi-plus'
          this.expandLancamento = false
        }
      },

      async expandedNomeLancamento (value) {
        if (this.iconeNome === 'mdi-minus' && this.iconeLancamento === 'mdi-minus') {
          this.expandNomeLancamento = true
          this.expandLancamento = false
          this.expandNome = false
          this.dadosDetalhamentoNome = []
          this.dadosDetalhamentoLancamento = []

          this.loading = true

          await ContasReceber.showInadimplenciaClientesNomeLancamento(this.primeiroDia, this.ultimoDia, this.select, this.valorReceber, this.valorVencido, localStorage.tokencontrato, this.selectClientes).then(resposta => {
            if (resposta.data.status) {
              this.dadosDetalhamentoNomeLancamento = resposta.data.dadosExibicao.map((item) => {
                var listaDetalhamento = ({
                  nome_reduzido: item.nome_reduzido,
                  cod_lancamento: item.cod_lancamento,
                  valor_vencido: item.valor_vencido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  porcentagem_vendido: item.porcentagem_vendido,
                  dias_vencido: item.dias_vencido,
                  valor_aberto: item.valor_aberto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                  porcentagem_inadiplencia: item.porcentagem_inadiplencia,
                })

                return listaDetalhamento
              })
            } else if (resposta.data.msg === 'Não há dados disponíveis') {
              this.dadosDetalhamentoNomeLancamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.error = e.message

              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => { this.loading = false })
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
      max-width: 395px !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }
</style>

<style lang="sass">
  #bloco1
    margin-left: -5rem

  #templateNome
    margin-left: -1rem

  #templateLancamento
    margin-left: -1rem

  #templateDataVencimento
    margin-left: -1rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)

</style>
